module.exports = __webpack_public_path__ + "media/images/categories/headers/countries-and-cultures-5729c7fb2f75ed68eb225f6006c113dc.jpg";